import { render, staticRenderFns } from "./Pro.vue?vue&type=template&id=b2707b20&scoped=true&"
import script from "./Pro.vue?vue&type=script&lang=js&"
export * from "./Pro.vue?vue&type=script&lang=js&"
import style0 from "./Pro.vue?vue&type=style&index=0&id=b2707b20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2707b20",
  null
  
)

export default component.exports